module.exports = __webpack_public_path__ + "img/cracker-banana-minuscules.0bc32aad.jpg";